import { useState } from "react";
import { SubmitHandler, useForm as useReactHookForm } from "react-hook-form";
import { useI18next } from "gatsby-plugin-react-i18next";
import { Routes } from "@routes";

export const useForm = () => {
  const [sendError, setSendError] = useState<boolean>();
  const [isLoading, setLoading] = useState<boolean>(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
  } = useReactHookForm();
  const { navigate } = useI18next();
  const { language } = useI18next();

  const onSubmit: SubmitHandler<{
    email: string;
    name: string;
  }> = async (data) => {
    if (sendError) {
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.GATSBY_NEWSLETTER_API_URL}/subscribe`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${process.env.GATSBY_NEWSLETTER_API_KEY}`,
          },
          body: JSON.stringify({
            email: data.email,
            name: data.name,
            language,
          }),
        }
      );

      if (response.ok) {
        setSendError(false);
        navigate(Routes.ThankYouNewsletter, { state: { fromForm: true } });
        setLoading(false);
      } else {
        setSendError(true);
      }
    } catch (error) {
      setSendError(true);
    } finally {
      setLoading(false);
      resetField("email");
      resetField("name");
    }
  };

  return {
    register,
    handleSubmit: handleSubmit(onSubmit),
    errors,
    isLoading,
    sendError,
  };
};
